'use client'
import { useState } from 'react';
import ArrowForwardOutlined from '@mui/icons-material/ArrowForwardOutlined';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import { DatePicker } from '../Forms/DatePicker';
import styles from './PeriodPanel.module.css';

interface PeriodPanelProps {
	dateFrom: string;
	dateTo: string;
	requireEndDate?: boolean;
	onChange: (from: string, to: string) => void;
	onClose: () => void;
}

export const PeriodPanel = ({ dateFrom, dateTo, requireEndDate = false, onChange, onClose }: PeriodPanelProps) => {
	const [localFrom, setLocalFrom] = useState(dateFrom);
	const [localTo, setLocalTo] = useState(dateTo);

	const handleApply = () => {
		onChange(localFrom, localTo);
		onClose();
	};

	return (
		<>
			<div className={styles.header}>
				<span className={styles.title}>Selecione o intervalo</span>
			</div>

			<div className={styles.fields}>
				<div className={styles.field}>
					<span className={styles.label}>De</span>
					<DatePicker
						value={localFrom}
						onChange={(v) => {
							setLocalFrom(v);
							if (localTo && v > localTo) setLocalTo('');
						}}
						placeholder="DD/MM/AAAA"
						dropdownAlign="left"
					/>
				</div>

				<div className={styles.separator}>
					<ArrowForwardOutlined className={styles.separatorIcon} />
				</div>

				<div className={styles.field}>
					<span className={styles.label}>Até</span>
					<DatePicker
						value={localTo}
						onChange={(v) => {
							setLocalTo(v);
							if (localFrom && v < localFrom) setLocalFrom('');
						}}
						placeholder="DD/MM/AAAA"
						dropdownAlign="right"
					/>
				</div>
			</div>

			<button type="button" className={styles.applyBtn} onClick={handleApply} disabled={!localFrom || (requireEndDate && !localTo)}>
				<CheckOutlined className={styles.applyIcon} />
				Aplicar
			</button>
		</>
	);
};
